import clsx from 'clsx';
import { MorphBox } from 'app/_shared'
import styles from './Error.module.scss'

export default ({ children, className }) => (
  <MorphBox className={styles.outer}>
    { children &&
      <div className={clsx(styles.error, className)}>{children}</div>
    }
  </MorphBox>
)
